import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { DureeExecutionByType, NatureAbandon, PeriodeExecutionByType, Prestation, PrestationStatut, PrestationStatutString, StatutBeneficiaire } from 'src/app/shared/models/prestation';
import { SortOrder } from 'src/app/shared/pipes/order-by/order-by.pipe';
import {
	PrestationType,
	PrestationTypeString
} from 'src/app/shared/models/prestation';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';
import { PrestationModalDetailSuiviPrestationComponent } from '../modal/prestation-modal-detail-suiviPrestation/prestation-modal-detail-suiviPrestation.component';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { ActivitePrestationModalAjoutComponent } from '../activitePrestation/activitePrestation-modal-ajout/activitePrestation-modal-ajout.component';
import { PrestationModalDetailActivitePrestationComponent } from '../modal/prestation-modal-detail-activitePrestation/prestation-modal-detail-activitePrestation.component';
import { PrestationFichier } from 'src/app/shared/models/prestationFichier';
import { PrestationFichierModalAjoutComponent } from '../prestationFichier/prestationFichier-modal-ajout/prestationFichier-modal-ajout.component';
import * as saveAs from 'file-saver';
import { AideTypeStringEnum, ResitutionTypeEnumString, RestitutionPrestation } from 'src/app/shared/models/restitutionPrestation';
import { RestitutionPrestationModalAjoutComponent } from '../restitutionPrestation/restitutionPrestation-modal-ajout/restitutionPrestation-modal-ajout.component';
import { PrestationModalDetailRestitutionPrestationComponent } from '../modal/prestation-modal-detail-restitutionPrestation/prestation-modal-detail-restitutionPrestation.component';

@Component({
	selector: 'app-detail-prestation',
	templateUrl: './detail-prestation.component.html',
	styleUrls: ['./detail-prestation.component.scss']
})
export class DetailPrestationComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z'éèàç._-]+( [0-9a-zA-Z'éèàç._-]+)*$");

	prestation: Prestation = null;
	confirmDeleteModalRef: BsModalRef;
	confirmDeleteFichierModalRef: BsModalRef;
	competences;
	disableButtonAddSuivi = false;
	showRestitution = false;
	isDeletable: boolean;
	isQDSelected = false;
	isSPSelected = false;

	suiviPrestationList : SuiviPrestation[];
	prestationFichierList : PrestationFichier[];
	currentPageSuivi = 1;
	sortOrderSuivi: SortOrder = 'asc';
	detailSuiviPrestationModalRef: BsModalRef;
	ajoutSuiviModalref: BsModalRef;
	ajoutFichierModalref: BsModalRef;
	ResitutionTypeEnumString = ResitutionTypeEnumString;
	PrestationTypeString = PrestationTypeString;


	activitePrestationList : ActivitePrestation[];
	restitutionPrestationList : RestitutionPrestation[];
	currentPageActivite = 0;
	currentPageRestitution = 0;
	currentPageFichier = 0;
	sortOrderActivite: SortOrder = 'desc';
	sortOrderRestitution: SortOrder = 'asc';
	detailActivitePrestationModalRef: BsModalRef;
	ajoutActiviteModalref: BsModalRef;
	detailRestitutionPrestationModalRef: BsModalRef;
	ajoutRestitutionModalref: BsModalRef;
	idActivitePrestationToDelete : number;
	idRestitutionPrestationToDelete : number;
	
	labelIntervenantCapitalized: string;

	isFormReadOnly = true;

	itemsPerPage = 10;
	isListingLoadingSuivi: boolean = true;
	isListingLoadingActivite: boolean = true;
	isListingLoadingRestitution: boolean = true;
	isAddable = true;

	prestationDetailForm = new FormGroup({
		typePrestation: new FormControl('', Validators.required),
		dateDepot: new FormControl<Date>(null),
		dateDebut: new FormControl<Date>(null, Validators.required),
		dateFin: new FormControl<Date>(null),
		dateValidation: new FormControl<Date>(null),
		dateLimite: new FormControl<Date>(null, Validators.required),
		statut: new FormControl(''),
		natureAbandon: new FormControl(''),
		commentaireAbandon: new FormControl(''),
		etatQualification: new FormControl(''),
		intervenant: new FormControl(),
		intervenantModule: new FormControl(),
		beneficiaire: new FormControl('', Validators.required),
		situation: new FormControl(''),
		raison: new FormControl(''),
		imperatifs: new FormControl(''),
		origineDemande: new FormControl(''),
		prescripteur: new FormControl(''),
		prescripteurContact: new FormControl(''),
		raisonDemandeAccomp: new FormControl(''),
		objectifPro: new FormControl(''),
		metiersCibles: new FormControl(''),
		typeAccompagnement: new FormControl(''),
		difficultes: new FormControl(''),
		besoins: new FormControl(''),
		origineHandicap: new FormControl(''),
		rapportHandicap: new FormControl(''),
		logement: new FormControl(''),
		sante: new FormControl(''),
		situationFinanciere: new FormControl(''),
		situationFamiliale: new FormControl(''),
		smBilan: new FormControl(''),
		smAccomp: new FormControl(''),
		deMetiersCibles: new FormControl(''),
		deProjetPro: new FormControl(''),
		deRuptureParcours: new FormControl(''),
		deBesoinsIdent: new FormControl(''),
		eeLimites: new FormControl(''),
		eeQuestEmploi: new FormControl(''),
		eeBesoinsAdapt: new FormControl(''),
		eePbAccess: new FormControl(''),
		eeAccompDejaMene: new FormControl(''),
		eeNomEntreprise: new FormControl(''),
		eeNomContactEntreprise: new FormControl(''),
		eePrenomContactEntreprise: new FormControl(''),
		eeMailContactEntreprise: new FormControl(''),
		eeTelContactEntreprise: new FormControl(''),
		eeSyntheseSitEmployeur: new FormControl(''),
		eeHoraires: new FormControl(''),
		eeFichePoste: new FormControl(''),
		efLimiteCapacite: new FormControl(''),
		efQuestionnement: new FormControl(''),
		efAccompDejaMene: new FormControl(''),
		efAccessibilite: new FormControl(''),
		efTypeFormation: new FormControl(),
		efBesoinsAt: new FormControl(''),
		efNomCentreFormation: new FormControl(''),
		efPlanning: new FormControl(''),
		efRemarqueRef: new FormControl(''),
		syntheseInfo: new FormControl(''),
		premieresOrientations: new FormControl(''),
		langage: new FormControl(''),
		praxie: new FormControl(''),
		memoire: new FormControl(''),
		fonctExecutif: new FormControl(''),
		fonctAttent: new FormControl(''),
		cognitionSociale: new FormControl(''),
		comportement: new FormControl(''),
		preconisations: new FormControl(''),
		observations: new FormControl(''),

		tauxReconnaissance: new FormControl(),
		niveauEtude: new FormControl(),
		niveauQualification: new FormControl(),
		statutProfessionnel: new FormControl(),
		eligibiliteBeneficiaire: new FormControl(),
		doleances: new FormControl(''),
		environnementSocial: new FormControl(''),
		// orientationMdph: new FormControl(''),
		// freins: new FormControl(''),
		// ressources: new FormControl(''),
		// contraintes: new FormControl(''),
		// propositionsActions: new FormControl(''),
		// planActionPerso: new FormControl(''),
		analyseAdequation: new FormControl(''),
		recommandantions: new FormControl(''),
		duree: new FormControl(null, Validators.required),
		dureePrevisionnelle: new FormControl(null, Validators.required),
		periode: new FormControl(null, Validators.required),
		statutBeneficiaire: new FormControl(''),
		bonCommande: new FormControl(),
		numeroCommande: new FormControl(''),

		// datePrescription: new FormControl(''),
		// datePremierContact: new FormControl(''),
		// datePremierRv: new FormControl(''),
		// dateS3: new FormControl(''),
		// dateS6: new FormControl(''),
		// preconisationsProposes: new FormControl(''),
		// comprehensionPreco: new FormControl(''),
		// description: new FormControl(''),
		// complements: new FormControl(''),
		// nomS3: new FormControl(''),
		// prenomS3: new FormControl(''),
		// fonctionS3: new FormControl(''),
		// preconisationMeoS3: new FormControl(''),
		// descriptionS3: new FormControl(''),
		// freinS3: new FormControl(''),
		// reponseS3: new FormControl(''),
		// nomS6: new FormControl(''),
		// prenomS6: new FormControl(''),
		// fonctionS6: new FormControl(''),
		// preconisationMeoS6: new FormControl(''),
		// descriptionS6: new FormControl(''),
		// freinS6: new FormControl(''),
		// reponseS6: new FormControl(''),
		dateContactPrescripteur: new FormControl(''),
		dateContactPersonne: new FormControl(''),
		dateContactEmployeur: new FormControl(''),
		meoSolutions: new FormControl(''),
		precoNonMeo: new FormControl(''),
		raisons: new FormControl(''),
		propositionAs: new FormControl(''),
		propositionAutre: new FormControl(''),
		propositionAutreDetails: new FormControl(''),
		heuresDeclarees: new FormControl(''),

		ressourcesFinancieres: new FormControl(''),
		niveauRendement: new FormControl(''),
		satisfaction: new FormControl(''),
		stress: new FormControl(''),
		forces: new FormControl(''),
		attention: new FormControl(''),
		gnosies: new FormControl(''),
		pointVigilence: new FormControl(''),
		ppIntitulePoste: new FormControl(''),
		ppDescriptionPosteBenef: new FormControl(''),
		ppDescriptionPosteOf: new FormControl(''),
		ppEntrepriseVise: new FormControl(''),

		idQualification: new FormControl(),
		showServiceChefFile: new FormControl(),
		serviceChefFile: new FormControl(),

		dateDebutContrat: new FormControl<Date>(null),
		dateFinContrat: new FormControl<Date>(null),
		salarieEntreprise: new FormControl(),
		accordEmployeur: new FormControl(),
		arretTravail: new FormControl(),
		agentFonctPub: new FormControl(),
		accordHandicap: new FormControl(),
	});

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isLoadingBeneficiaires: { value: boolean } = { value: true };

	//Employé.e extérieur
	isEmpExt = false;

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationType = PrestationType;

	public PrestationStatutStringEnum = PrestationStatutString;
	public PrestationStatut = PrestationStatut;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.isDeletable = true;

		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.prestationService
			.getPrestationById(id)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
				console.log(prestation);
				// this.facade.suiviPrestationService.getByPrestation(this.prestation.id).subscribe({
				// 	next: (val) => {
				// 		this.suiviPrestationList = val;
				// 	}
				// });
				if(this.prestation.typePrestation == PrestationType.QD){
					this.isQDSelected = true;
				}else{
					this.showRestitution = true;
				}
				if(this.prestation.typePrestation == PrestationType.SP){
					this.isSPSelected = true;
				}
				if(this.prestation.statut != PrestationStatut.COURS){
					this.disableButtonAddSuivi = true;
				}
				this.facade.activitePrestationService.getByPrestation(this.prestation.id).subscribe({
					next: (val) => {
						this.activitePrestationList = val;
						console.log(this.activitePrestationList);
					}
				});
				this.facade.restitutionPrestationService.getByPrestation(this.prestation?.typePrestation == PrestationType.QD? this.prestation.id : this.prestation.idQualification).subscribe({
					next: (val) => {
						this.restitutionPrestationList = val;
					}
				});
				this.facade.prestationFichierService.getByPrestation(this.prestation.id).subscribe({
					next: (val) => {
						this.prestationFichierList = val;
					}
				});
			});
	}

	goBack(): void {
		this.router.navigate(['/prestation/appuis-specifiques/list']);
	}

	delete(prestation: Prestation): void {
		if (this.isDeletable) {
			this.facade.prestationService.deletePrestation(prestation.id).subscribe({
				complete: () => {
					this.modalService.hide();
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.modalService.hide();
				}
			});
		}
	}

	deletePrestationFichier(idPrestationFichierToDelete : number): void {
			this.facade.prestationFichierService.deletePrestationFichier(idPrestationFichierToDelete).subscribe({
				complete: () => {
					this.reload();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.modalService.hide();
				}
			});
	}

	download(prestationFichier : PrestationFichier): void {
		// this.facade.exportService
		// 		.exportMissionPlaces()
		// 		.subscribe((blob) => saveAs(blob, 'missionPlaces.csv'));
		this.facade.prestationFichierService.downloadFile(prestationFichier.id).subscribe(
			(blob) => {
			saveAs(blob, prestationFichier.filename)})
			
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	openConfirmDeleteFichierModal(confirmDeleteFichierTemplate: TemplateRef<any>, prestationFichierId : number): void {
		this.idActivitePrestationToDelete = prestationFichierId;
		this.confirmDeleteFichierModalRef = this.modalService.show(confirmDeleteFichierTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;

		if (isSubmit) {
			this.facade.prestationService.getPrestationById(this.prestation.id).subscribe({
				next: (prestation: Prestation) => {
					this.prestation = prestation;
					this.resetForm();
				},
				error: (err) => {
					this.isValidateButtonClicked.value = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.resetForm();
				}
			});
		}
	}

	onSubmit() {
		if (
			this.prestationDetailForm.valid
		){
			console.log(this.prestation);
			this.updateVolHorairePrevisionnel(this.prestation);
			switch(this.prestation.typePrestation) { 
				case PrestationType.QD: { 
				   this.facade.qualificationService.updateQualification(this.prestation).subscribe({
						next: (val) => { 
							if(this.prestation.modules?.length > 0){
								this.prestation.modules.forEach((currentValue) => {
									switch(currentValue) { 
										case PrestationType.AC: {
											let ac = new Prestation();
											ac.statut = this.PrestationStatut.COURS;
											ac.beneficiaire = this.prestation.beneficiaire;
											ac.statutBeneficiaire = this.prestation.statutBeneficiaire;
											ac.typePrestation = this.prestation.typePrestation;
											ac.dateDebut = this.prestation.dateDebut
											ac.metiersCibles = this.prestation.metiersCibles;
											ac.intervenant = this.prestation.intervenantModule;
											ac.service = this.prestation.service;
											ac.serviceChefFile = this.prestation.serviceChefFile;
											ac.bonCommande = this.prestation.bonCommande;
											ac.prescripteur = this.prestation.prescripteur;
											ac.numeroCommande = this.prestation.numeroCommande;
											ac.prescripteurContact = this.prestation.prescripteurContact;
											ac.periode = PeriodeExecutionByType[PrestationType.AC];
											ac.duree = DureeExecutionByType[PrestationType.AC];
											ac.dureePrevisionnelle = ac.duree;
											ac.idQualification = val.id;
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												ac.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.AC])).toUTCString();
											}
											this.updateVolHorairePrevisionnel(ac);
											 
											this.facade.capaciteService.addCapacite(ac).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.AS: {
											let as = new Prestation();
											as.statut = this.PrestationStatut.COURS;
											as.beneficiaire = this.prestation.beneficiaire;
											as.statutBeneficiaire = this.prestation.statutBeneficiaire;
											as.typePrestation = this.prestation.typePrestation;
											as.dateDebut = this.prestation.dateDebut
											as.intervenant = this.prestation.intervenantModule;
											as.service = this.prestation.service;
											as.serviceChefFile = this.prestation.serviceChefFile;
											as.bonCommande = this.prestation.bonCommande;
											as.numeroCommande = this.prestation.numeroCommande;
											as.prescripteur = this.prestation.prescripteur;
											as.prescripteurContact = this.prestation.prescripteurContact;
											as.periode = PeriodeExecutionByType[PrestationType.AS];
											as.duree = DureeExecutionByType[PrestationType.AS];
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												as.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.AS])).toUTCString();
											}
											as.dureePrevisionnelle = as.duree;
											as.idQualification = val.id;
											this.updateVolHorairePrevisionnel(as);
											 
											this.facade.situationPrestationService.addSituationPrestation(as).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.CAMEO: {
											let cameo = new Prestation();
											cameo.statut = this.PrestationStatut.COURS;
											cameo.beneficiaire = this.prestation.beneficiaire;
											cameo.statutBeneficiaire = this.prestation.statutBeneficiaire;
											cameo.typePrestation = this.prestation.typePrestation;
											cameo.dateDebut = this.prestation.dateDebut
											cameo.intervenant = this.prestation.intervenantModule;
											cameo.service = this.prestation.service;
											cameo.serviceChefFile = this.prestation.serviceChefFile;
											cameo.bonCommande = this.prestation.bonCommande;
											cameo.numeroCommande = this.prestation.numeroCommande;
											cameo.prescripteur = this.prestation.prescripteur;
											cameo.prescripteurContact = this.prestation.prescripteurContact;
											cameo.periode = PeriodeExecutionByType[PrestationType.CAMEO];
											cameo.duree = DureeExecutionByType[PrestationType.CAMEO];
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												cameo.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.CAMEO])).toUTCString();
											}
											cameo.dureePrevisionnelle = cameo.duree;
											cameo.idQualification = val.id;
											this.updateVolHorairePrevisionnel(cameo);
											 
											this.facade.miseEnOeuvreEmploiService.addMiseEnOeuvreEmploi(cameo).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.EAP: {
											let eap = new Prestation();
											eap.statut = this.PrestationStatut.COURS;
											eap.beneficiaire = this.prestation.beneficiaire;
											eap.statutBeneficiaire = this.prestation.statutBeneficiaire;
											eap.typePrestation = this.prestation.typePrestation;
											eap.dateDebut = this.prestation.dateDebut
											eap.intervenant = this.prestation.intervenantModule;
											eap.service = this.prestation.service;
											eap.serviceChefFile = this.prestation.serviceChefFile;
											eap.bonCommande = this.prestation.bonCommande;
											eap.numeroCommande = this.prestation.numeroCommande;
											eap.prescripteur = this.prestation.prescripteur;
											eap.prescripteurContact = this.prestation.prescripteurContact;
											eap.periode = PeriodeExecutionByType[PrestationType.EAP];
											eap.duree = DureeExecutionByType[PrestationType.EAP];
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												eap.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.EAP])).toUTCString();
											}
											eap.dureePrevisionnelle = eap.duree;
											eap.idQualification = val.id;
											this.updateVolHorairePrevisionnel(eap);
											 
											this.facade.evaluationService.addEvaluation(eap).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.SP: {
											let sp = new Prestation();
											sp.statut = this.PrestationStatut.COURS;
											sp.beneficiaire = this.prestation.beneficiaire;
											sp.statutBeneficiaire = this.prestation.statutBeneficiaire;
											sp.typePrestation = this.prestation.typePrestation;
											sp.dateDebut = this.prestation.dateDebut
											sp.intervenant = this.prestation.intervenantModule;
											sp.service = this.prestation.service;
											sp.serviceChefFile = this.prestation.serviceChefFile;
											sp.bonCommande = this.prestation.bonCommande;
											sp.numeroCommande = this.prestation.numeroCommande;
											sp.prescripteur = this.prestation.prescripteur;
											sp.prescripteurContact = this.prestation.prescripteurContact;
											sp.periode = PeriodeExecutionByType[PrestationType.SP];
											sp.duree = DureeExecutionByType[PrestationType.SP];
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												sp.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.SP])).toUTCString();
											}
											sp.dureePrevisionnelle = sp.duree;
											sp.idQualification = val.id;
											this.updateVolHorairePrevisionnel(sp);
											 
											this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
												next: (val) => {
												}
											});
											break;
										}
									}
								})
							}
						},
						complete:()=>{
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.situationPrestationService
								.getSituationPrestationById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
				} 
				case PrestationType.AC: { 
					console.log(this.prestation)
					this.facade.capaciteService.updateCapacite(this.prestation).subscribe({
						complete: () => {
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.situationPrestationService
								.getSituationPrestationById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
				}
				case PrestationType.AS: { 
					console.log(this.prestation);
					this.facade.situationPrestationService.updateSituationPrestation(this.prestation).subscribe({
						complete: () => {
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.situationPrestationService
								.getSituationPrestationById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
				}
				case PrestationType.CAMEO: { 
					this.facade.miseEnOeuvreEmploiService.updateMiseEnOeuvreEmploi(this.prestation).subscribe({
						complete: () => {
							if((this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPRIV || this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPUB) 
								&& this.prestation.statut == PrestationStatut.CLOT && this.prestation.natureAbandon == NatureAbandon.NATABANDON8){
								if(!this.prestation.modules.some(e => e === PrestationType.SP)){
									console.log("ci biir");
									let sp = new Prestation();
											sp.statut = this.PrestationStatut.COURS;
											sp.beneficiaire = this.prestation.beneficiaire;
											sp.statutBeneficiaire = this.prestation.statutBeneficiaire;
											sp.typePrestation = PrestationType.SP;
											sp.dateDebut = this.prestation.dateFin
											sp.service = this.prestation.service;
											sp.serviceChefFile = this.prestation.serviceChefFile;
											//sp.bonCommande = this.prestation.bonCommande;
											sp.numeroCommande = this.prestation.numeroCommande;
											sp.prescripteur = this.prestation.prescripteur;
											sp.prescripteurContact = this.prestation.prescripteurContact;
											sp.periode = PeriodeExecutionByType[PrestationType.SP];
											sp.duree = DureeExecutionByType[PrestationType.SP];
											sp.intervenant = this.prestation.intervenantModule;
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												sp.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.SP])).toUTCString();
											}
											sp.dureePrevisionnelle = sp.duree;
											sp.idQualification = this.prestation.idQualification;
											this.updateVolHorairePrevisionnel(sp);
											 
											this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
												next: (val) => {
													
												}
											});
								}
							}
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.miseEnOeuvreEmploiService
								.getMiseEnOeuvreEmploiById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
					break; 
				}
				case PrestationType.EAP: { 
					this.facade.evaluationService.updateEvaluation(this.prestation).subscribe({
						complete: () => {
							if((this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPRIV || this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPUB) 
								&& this.prestation.statut == PrestationStatut.CLOT && this.prestation.natureAbandon == NatureAbandon.NATABANDON8){
								if(!this.prestation.modules.some(e => e === PrestationType.SP)){
									console.log("ci biir");
									let sp = new Prestation();
											sp.statut = this.PrestationStatut.COURS;
											sp.beneficiaire = this.prestation.beneficiaire;
											sp.statutBeneficiaire = this.prestation.statutBeneficiaire;
											sp.typePrestation = PrestationType.SP;
											sp.dateDebut = this.prestation.dateFin
											sp.service = this.prestation.service;
											sp.serviceChefFile = this.prestation.serviceChefFile;
											//sp.bonCommande = this.prestation.bonCommande;
											sp.numeroCommande = this.prestation.numeroCommande;
											sp.prescripteur = this.prestation.prescripteur;
											sp.prescripteurContact = this.prestation.prescripteurContact;
											sp.periode = PeriodeExecutionByType[PrestationType.SP];
											sp.duree = DureeExecutionByType[PrestationType.SP];
											sp.intervenant = this.prestation.intervenantModule;
											if(this.prestation.dateDebut != null){
												let calculatedDateLimite = new Date(this.prestation.dateDebut);
												sp.dateLimite = new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth()+PeriodeExecutionByType[PrestationType.SP])).toUTCString();
											}
											sp.dureePrevisionnelle = sp.duree;
											sp.idQualification = this.prestation.idQualification;
											this.updateVolHorairePrevisionnel(sp);
											 
											this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
												next: (val) => {
													
												}
											});
								}
							}
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.evaluationService
								.getEvaluationById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
				}
				case PrestationType.SP: { 
					this.facade.suiviPrecoService.updateSuiviPreco(this.prestation).subscribe({
						complete: () => {
							this.isValidateButtonClicked.value = false;
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.suiviPrecoService
								.getSuiviPrecoById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				   break; 
				}
				default: { 
				   break; 
				} 
			 }
		} else {
			this.isValidateButtonClicked.value = false;
			// this.facade.toastService.createErrorToast();
		}
	}

	resetForm() {
		this.prestationDetailForm.reset();
		this.prestationDetailForm.patchValue({
			typePrestation: this.prestation.typePrestation,
			statut: this.prestation.statut,
			etatQualification: this.prestation.etatQualification,
			dateDebut:
				this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
					? new Date(this.prestation.dateDebut)
					: null,
			dateFin:
			this.prestation.dateFin !== null && this.prestation.dateFin !== ''
					? new Date(this.prestation.dateFin)
					: null,
			dateValidation:
				this.prestation.dateValidation !== null && this.prestation.dateValidation !== ''
					? new Date(this.prestation.dateValidation)
					: null,
			dateLimite:
				this.prestation.dateLimite !== null && this.prestation.dateLimite !== ''
					? new Date(this.prestation.dateLimite)
					: null,
			//beneficiaire: this.prestation.beneficiaire,
			//situation: this.prestation.situation,
			raison : this.prestation.raison,
			imperatifs : this.prestation.imperatifs,
			//origineDemande: this.prestation.origineDemande,
			//prescripteur: null,
			raisonDemandeAccomp: this.prestation.raisonDemandeAccomp,
			//objectifPro: null,
			duree: this.prestation.duree,
			periode: this.prestation.periode,
			metiersCibles: this.prestation.metiersCibles,
			typeAccompagnement: this.prestation.typeAccompagnement,
			difficultes: this.prestation.difficultes,
			besoins: this.prestation.besoins,
			origineHandicap: this.prestation.origineHandicap,
			rapportHandicap: this.prestation.rapportHandicap,
			logement: this.prestation.logement,
			sante: this.prestation.sante,
			situationFinanciere: this.prestation.situationFinanciere,
			situationFamiliale: this.prestation.situationFamiliale,
			smBilan: this.prestation.smBilan,
			smAccomp: this.prestation.smAccomp,
			deMetiersCibles: this.prestation.deMetiersCibles,
			deProjetPro: this.prestation.deProjetPro,
			deRuptureParcours: this.prestation.deRuptureParcours,
			deBesoinsIdent: this.prestation.deBesoinsIdent,
			eeLimites: this.prestation.eeLimites,
			eeQuestEmploi: this.prestation.eeQuestEmploi,
			eeBesoinsAdapt: this.prestation.eeBesoinsAdapt,
			eePbAccess: this.prestation.eePbAccess,
			eeAccompDejaMene: this.prestation.eeAccompDejaMene,
			eeNomEntreprise: this.prestation.eeNomEntreprise,
			eeNomContactEntreprise: this.prestation.eeNomContactEntreprise,
			eePrenomContactEntreprise: this.prestation.eePrenomContactEntreprise,
			eeMailContactEntreprise: this.prestation.eeMailContactEntreprise,
			eeTelContactEntreprise: this.prestation.eeTelContactEntreprise,
			eeSyntheseSitEmployeur: this.prestation.eeSyntheseSitEmployeur,
			eeHoraires: this.prestation.eeHoraires,
			eeFichePoste: this.prestation.eeFichePoste,
			efLimiteCapacite: this.prestation.efLimiteCapacite,
			efQuestionnement: this.prestation.efQuestionnement,
			efAccompDejaMene: this.prestation.efAccompDejaMene,
			efAccessibilite: this.prestation.efAccessibilite,
			efTypeFormation: this.prestation.efTypeFormation,
			efBesoinsAt: this.prestation.efBesoinsAt,
			efNomCentreFormation: this.prestation.efNomCentreFormation,
			efPlanning: this.prestation.efPlanning,
			efRemarqueRef: this.prestation.efRemarqueRef,
			syntheseInfo: this.prestation.syntheseInfo,
			premieresOrientations: this.prestation.premieresOrientations,
			langage: this.prestation.langage,
			praxie: this.prestation.praxie,
			memoire: this.prestation.memoire,
			fonctExecutif: this.prestation.fonctExecutif,
			fonctAttent: this.prestation.fonctAttent,
			cognitionSociale: this.prestation.cognitionSociale,
			comportement: this.prestation.comportement,
			preconisations: this.prestation.preconisations,
			observations: this.prestation.observations,
			// orientationMdph: this.prestation.orientationMdph,
			// freins: this.prestation.freins,
			// ressources: this.prestation.ressources,
			// contraintes: this.prestation.contraintes,
			// propositionsActions: this.prestation.propositionsActions,
			// planActionPerso: this.prestation.planActionPerso,
			analyseAdequation: this.prestation.analyseAdequation,
			recommandantions: this.prestation.recommandantions,
			statutBeneficiaire: this.prestation.statutBeneficiaire,
			bonCommande: this.prestation.bonCommande,
			serviceChefFile: this.prestation.serviceChefFile
		})
	}

	openModalDetailSuivi(suiviPrestation: SuiviPrestation): void {
		const initialState = {
			suiviPrestation: suiviPrestation,
			prestation: this.prestation
		};
		this.detailSuiviPrestationModalRef = this.modalService.show(
			PrestationModalDetailSuiviPrestationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	openModalDetailActivite(activitePrestation: ActivitePrestation): void {
		const initialState = {
			activitePrestation: activitePrestation,
			prestation: this.prestation
		};
		this.detailActivitePrestationModalRef = this.modalService.show(
			PrestationModalDetailActivitePrestationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	openModalDetailRestitution(restitutionPrestation: RestitutionPrestation): void {
		const initialState = {
			restitutionPrestation: restitutionPrestation,
			prestation: this.prestation
		};
		this.detailRestitutionPrestationModalRef = this.modalService.show(
			PrestationModalDetailRestitutionPrestationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	// intervenantAsString() {
	// 	let str = '';
	// 	this.prestation.intervenants.sort((a, b) => a.name.localeCompare(b.name))
	// 		.forEach((e) => (str += e.name + ', '));
	// 	return str.slice(0, -2);
	// }

	get typePrestation() {
		return this.prestationDetailForm.get('typePrestation');
	}
	get dateDebut() {
		return this.prestationDetailForm.get('dateDebut');
	}
	get dateFin() {
		return this.prestationDetailForm.get('dateFin');
	}
	get dateValidation() {
		return this.prestationDetailForm.get('dateValidation');
	}
	get dateLimite() {
		return this.prestationDetailForm.get('dateLimite');
	}
	get statut() {
		return this.prestationDetailForm.get('statut');
	}
	get natureAbandon() {
		return this.prestationDetailForm.get('natureAbandon');
	}
	get commentaireAbandon() {
		return this.prestationDetailForm.get('commentaireAbandon');
	}
	get etatQualification() {
		return this.prestationDetailForm.get('etatQualification');
	}
	get intervenants() {
		return this.prestationDetailForm.get('intervenants');
	}
	get intervenant() {
		return this.prestationDetailForm.get('intervenant');
	}
	get beneficiaire() {
		return this.prestationDetailForm.get('beneficiaire');
	}
	get raison() {
		return this.prestationDetailForm.get('raison');
	}
	get imperatifs() {
		return this.prestationDetailForm.get('imperatifs');
	}
	get situation() {
		return this.prestationDetailForm.get('situation');
	}
	get origineDemande() {
		return this.prestationDetailForm.get('origineDemande');
	}
	get prescripteur() {
		return this.prestationDetailForm.get('prescripteur');
	}
	get prescripteurContact() {
		return this.prestationDetailForm.get('prescripteurContact');
	}
	get raisonDemandeAccomp() {
		return this.prestationDetailForm.get('raisonDemandeAccomp');
	}
	get objectifPro() {
		return this.prestationDetailForm.get('objectifPro');
	}
	get metiersCibles() {
		return this.prestationDetailForm.get('metiersCibles');
	}
	get typeAccompagnement() {
		return this.prestationDetailForm.get('typeAccompagnement');
	}
	get difficultes() {
		return this.prestationDetailForm.get('difficultes');
	}
	get besoins() {
		return this.prestationDetailForm.get('besoins');
	}
	get origineHandicap() {
		return this.prestationDetailForm.get('origineHandicap');
	}
	get rapportHandicap() {
		return this.prestationDetailForm.get('rapportHandicap');
	}
	get logement() {
		return this.prestationDetailForm.get('logement');
	}
	get sante() {
		return this.prestationDetailForm.get('sante');
	}
	get situationFinanciere() {
		return this.prestationDetailForm.get('situationFinanciere');
	}
	get situationFamiliale() {
		return this.prestationDetailForm.get('situationFamiliale');
	}
	get smBilan() {
		return this.prestationDetailForm.get('smBilan');
	}
	get smAccomp() {
		return this.prestationDetailForm.get('smAccomp');
	}
	get deMetiersCibles() {
		return this.prestationDetailForm.get('deMetiersCibles');
	}
	get deProjetPro() {
		return this.prestationDetailForm.get('deProjetPro');
	}
	get deRuptureParcours() {
		return this.prestationDetailForm.get('deRuptureParcours');
	}
	get deBesoinsIdent() {
		return this.prestationDetailForm.get('deBesoinsIdent');
	}
	get eeLimites() {
		return this.prestationDetailForm.get('eeLimites');
	}
	get eeQuestEmploi() {
		return this.prestationDetailForm.get('eeQuestEmploi');
	}
	get eeBesoinsAdapt() {
		return this.prestationDetailForm.get('eeBesoinsAdapt');
	}
	get eePbAccess() {
		return this.prestationDetailForm.get('eePbAccess');
	}
	get eeAccompDejaMene() {
		return this.prestationDetailForm.get('eeAccompDejaMene');
	}
	get eeNomEntreprise() {
		return this.prestationDetailForm.get('eeNomEntreprise');
	}
	get eeNomContactEntreprise() {
		return this.prestationDetailForm.get('eeNomContactEntreprise');
	}
	get eePrenomContactEntreprise() {
		return this.prestationDetailForm.get('eePrenomContactEntreprise');
	}
	get eeMailContactEntreprise() {
		return this.prestationDetailForm.get('eeMailContactEntreprise');
	}
	get eeTelContactEntreprise() {
		return this.prestationDetailForm.get('eeTelContactEntreprise');
	}
	get eeSyntheseSitEmployeur() {
		return this.prestationDetailForm.get('eeSyntheseSitEmployeur');
	}
	get eeHoraires() {
		return this.prestationDetailForm.get('eeHoraires');
	}
	get eeFichePoste() {
		return this.prestationDetailForm.get('eeFichePoste');
	}
	get efLimiteCapacite() {
		return this.prestationDetailForm.get('efLimiteCapacite');
	}
	get efQuestionnement() {
		return this.prestationDetailForm.get('efQuestionnement');
	}
	get efAccompDejaMene() {
		return this.prestationDetailForm.get('efAccompDejaMene');
	}
	get efAccessibilite() {
		return this.prestationDetailForm.get('efAccessibilite');
	}
	get efTypeFormation() {
		return this.prestationDetailForm.get('efTypeFormation');
	}
	get efBesoinsAt() {
		return this.prestationDetailForm.get('efBesoinsAt');
	}
	get efNomCentreFormation() {
		return this.prestationDetailForm.get('efNomCentreFormation');
	}
	get efPlanning() {
		return this.prestationDetailForm.get('efPlanning');
	}
	get efRemarqueRef() {
		return this.prestationDetailForm.get('efRemarqueRef');
	}
	get syntheseInfo() {
		return this.prestationDetailForm.get('syntheseInfo');
	}
	get premieresOrientations() {
		return this.prestationDetailForm.get('premieresOrientations');
	}
	get langage() {
		return this.prestationDetailForm.get('langage');
	}
	get praxie() {
		return this.prestationDetailForm.get('praxie');
	}
	get memoire() {
		return this.prestationDetailForm.get('memoire');
	}
	get fonctExecutif() {
		return this.prestationDetailForm.get('fonctExecutif');
	}
	get fonctAttent() {
		return this.prestationDetailForm.get('fonctAttent');
	}
	get cognitionSociale() {
		return this.prestationDetailForm.get('cognitionSociale');
	}
	get comportement() {
		return this.prestationDetailForm.get('comportement');
	}
	get preconisations() {
		return this.prestationDetailForm.get('preconisations');
	}
	get observations() {
		return this.prestationDetailForm.get('observations');
	}
	// get orientationMdph() {
	// 	return this.prestationDetailForm.get('orientationMdph');
	// }
	// get freins() {
	// 	return this.prestationDetailForm.get('freins');
	// }
	// get ressources() {
	// 	return this.prestationDetailForm.get('ressources');
	// }
	// get contraintes() {
	// 	return this.prestationDetailForm.get('contraintes');
	// }
	// get propositionsActions() {
	// 	return this.prestationDetailForm.get('propositionsActions');
	// }
	// get planActionPerso() {
	// 	return this.prestationDetailForm.get('planActionPerso');
	// }
	get analyseAdequation() {
		return this.prestationDetailForm.get('analyseAdequation');
	}
	get recommandantions() {
		return this.prestationDetailForm.get('recommandantions');
	}
	get periode() {
		return this.prestationDetailForm.get('periode');
	}
	get duree() {
		return this.prestationDetailForm.get('duree');
	}
	get dureePrevisionnelle() {
		return this.prestationDetailForm.get('dureePrevisionnelle');
	}
	get statutBeneficiaire() {
		return this.prestationDetailForm.get('statutBeneficiaire');
	}
	get bonCommande() {
		return this.prestationDetailForm.get('bonCommande');
	}
	get numeroCommande() {
		return this.prestationDetailForm.get('numeroCommande');
	}
	// get datePrescription(){
	// 	return this.prestationDetailForm.get('datePrescription');
	// }
	// get datePremierContact(){
	// 	return this.prestationDetailForm.get('datePremierContact');
	// }
	// get datePremierRv(){
	// 	return this.prestationDetailForm.get('datePremierRv');
	// }
	// get dateS3(){
	// 	return this.prestationDetailForm.get('dateS3');
	// }
	// get dateS6(){
	// 	return this.prestationDetailForm.get('dateS6');
	// }
	// get preconisationsProposes(){
	// 	return this.prestationDetailForm.get('preconisationsProposes');
	// }
	// get comprehensionPreco(){
	// 	return this.prestationDetailForm.get('comprehensionPreco');
	// }
	// get description(){
	// 	return this.prestationDetailForm.get('description');
	// }
	// get complements(){
	// 	return this.prestationDetailForm.get('complements');
	// }
	// get nomS3(){
	// 	return this.prestationDetailForm.get('nomS3');
	// }
	// get prenomS3(){
	// 	return this.prestationDetailForm.get('prenomS3');
	// }
	// get fonctionS3(){
	// 	return this.prestationDetailForm.get('fonctionS3');
	// }
	// get preconisationMeoS3(){
	// 	return this.prestationDetailForm.get('preconisationMeoS3');
	// }
	// get descriptionS3(){
	// 	return this.prestationDetailForm.get('descriptionS3');
	// }
	// get freinS3(){
	// 	return this.prestationDetailForm.get('freinS3');
	// }
	// get reponseS3(){
	// 	return this.prestationDetailForm.get('reponseS3');
	// }
	// get nomS6(){
	// 	return this.prestationDetailForm.get('nomS6');
	// }
	// get prenomS6(){
	// 	return this.prestationDetailForm.get('prenomS6');
	// }
	// get fonctionS6(){
	// 	return this.prestationDetailForm.get('fonctionS6');
	// }
	// get preconisationMeoS6(){
	// 	return this.prestationDetailForm.get('preconisationMeoS6');
	// }
	// get descriptionS6(){
	// 	return this.prestationDetailForm.get('descriptionS6');
	// }
	// get freinS6(){
	// 	return this.prestationDetailForm.get('freinS6');
	// }
	// get reponseS6(){
	// 	return this.prestationDetailForm.get('reponseS6');
	// }
	get dateContactPrescripteur() {
		return this.prestationDetailForm.get('dateContactPrescripteur');
	}
	get dateContactPersonne() {
		return this.prestationDetailForm.get('dateContactPersonne');
	}
	get dateContactEmployeur() {
		return this.prestationDetailForm.get('dateContactEmployeur');
	}
	get meoSolutions() {
		return this.prestationDetailForm.get('meoSolutions');
	}
	get precoNonMeo() {
		return this.prestationDetailForm.get('precoNonMeo');
	}
	get raisons() {
		return this.prestationDetailForm.get('raisons');
	}
	get propositionAs() {
		return this.prestationDetailForm.get('propositionAs');
	}
	get propositionAutre() {
		return this.prestationDetailForm.get('propositionAutre');
	}
	get propositionAutreDetails() {
		return this.prestationDetailForm.get('propositionAutreDetails');
	}

	
	get ressourcesFinancieres(){
		return this.prestationDetailForm.get('ressourcesFinancieres');
	}
	get niveauRendement(){
		return this.prestationDetailForm.get('niveauRendement');
	}
	get satisfaction(){
		return this.prestationDetailForm.get('satisfaction');
	}
	get stress(){
		return this.prestationDetailForm.get('stress');
	}
	get forces(){
		return this.prestationDetailForm.get('forces');
	}
	get attention(){
		return this.prestationDetailForm.get('attention');
	}
	get gnosies(){
		return this.prestationDetailForm.get('gnosies');
	}
	get pointVigilence(){
		return this.prestationDetailForm.get('pointVigilence');
	}
	get ppIntitulePoste(){
		return this.prestationDetailForm.get('ppIntitulePoste');
	}
	get ppDescriptionPosteBenef(){
		return this.prestationDetailForm.get('ppDescriptionPosteBenef');
	}
	get ppDescriptionPosteOf(){
		return this.prestationDetailForm.get('ppDescriptionPosteOf');
	}
	get ppEntrepriseVise(){
		return this.prestationDetailForm.get('ppEntrepriseVise');
	}
	get idQualification(){
		return this.prestationDetailForm.get('idQualification');
	}
	get serviceChefFile(){
		return this.prestationDetailForm.get('serviceChefFile');
	}
	get showServiceChefFile(){
		return this.prestationDetailForm.get('showServiceChefFile');
	}


	getSuivis(): void {
		this.isListingLoadingSuivi = true;
		this.facade.suiviPrestationService.getByPrestation(this.prestation.id).subscribe({
			next: (suivis: SuiviPrestation[]) => {
				this.suiviPrestationList = suivis;
				console.log(this.suiviPrestationList);
				//this.listIntervenants = this.getPrestationsIntervenants(this.prestations);
				this.currentPageSuivi = 0;
				this.itemsPerPage = this.suiviPrestationList.length >= 5 ? 10 : 5;

				this.isListingLoadingSuivi = false;
			},
			error: (err: ErrorResponse) => {
				//this.logger.error(err + '');
				this.isListingLoadingSuivi = false;
			}
		});
	}

	getActivites(): void {
		this.isListingLoadingActivite = true;
		this.facade.activitePrestationService.getByPrestation(this.prestation.id).subscribe({
			next: (activites: ActivitePrestation[]) => {
				this.activitePrestationList = activites;
				console.log(this.activitePrestationList);
				this.currentPageActivite = 0;
				this.itemsPerPage = this.activitePrestationList.length >= 5 ? 10 : 5;

				this.isListingLoadingActivite = false;
			},
			error: (err: ErrorResponse) => {
				//this.logger.error(err + '');
				this.isListingLoadingActivite = false;
			}
		});
	}

	getRestitutions(): void {
		this.isListingLoadingRestitution = true;
		this.facade.restitutionPrestationService.getByPrestation(this.prestation.id).subscribe({
			next: (restitutions: RestitutionPrestation[]) => {
				this.restitutionPrestationList = restitutions;
				console.log(this.restitutionPrestationList);
				this.currentPageRestitution = 0;
				this.itemsPerPage = this.restitutionPrestationList.length >= 5 ? 10 : 5;

				this.isListingLoadingRestitution = false;
			},
			error: (err: ErrorResponse) => {
				//this.logger.error(err + '');
				this.isListingLoadingRestitution = false;
			}
		});
	}

	openModalSuiviPrestationAjout() {
		const initialState = {};
		this.ajoutFichierModalref = this.modalService.show(
			PrestationFichierModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutFichierModalref.onHide.subscribe((reason: string | any) => {
			this.getSuivis();
		});
	}

	openModalFichierAjout() {
		const initialState = {};
		this.ajoutSuiviModalref = this.modalService.show(
			PrestationFichierModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutSuiviModalref.onHide.subscribe((reason: string | any) => {
			this.getSuivis();
		});
	}

	openModalActivitePrestationAjout() {
		const initialState = {};
		this.ajoutActiviteModalref = this.modalService.show(
			ActivitePrestationModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutActiviteModalref.onHide.subscribe((reason: string | any) => {
			this.getActivites();
		});
	}

	openModalRestitutionPrestationAjout() {
		const initialState = {};
		this.ajoutRestitutionModalref = this.modalService.show(
			RestitutionPrestationModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutRestitutionModalref.onHide.subscribe((reason: string | any) => {
			this.getRestitutions();
		});
	}

	updateVolHorairePrevisionnel(prestation : Prestation) : void  {
		console.log(this.prestation.bonCommande);
		console.log(this.prestation.oldDuree);
		if(prestation.dureePrevisionnelle != null && prestation.bonCommande != null){
				if(prestation.id == null || prestation.dateAffectBdc == null){
					prestation.bonCommande.nombreHeuresPrevisionnelUtil = (prestation.bonCommande.nombreHeuresPrevisionnelUtil != null ? 
						prestation.bonCommande.nombreHeuresPrevisionnelUtil : 0) + prestation.dureePrevisionnelle;
				}else{
					prestation.bonCommande.nombreHeuresPrevisionnelUtil = (prestation.bonCommande.nombreHeuresPrevisionnelUtil != null ? 
						prestation.bonCommande.nombreHeuresPrevisionnelUtil : 0) - prestation.oldDuree + prestation.dureePrevisionnelle;
				}
			prestation.dateAffectBdc = new Date().toISOString().slice(0,10);
			this.facade.bonCommandeService.updateBonCommande(this.prestation.bonCommande).subscribe({
				
			});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
	
}
